export default {
  state: {
    roles: [],
    loading: false,
  },
  getters: {
    roles: state => state.roles,
    loading: state => state.loading,
  },
  mutations: {
    setRoles(state, roles) {
      state.roles = roles;
    },
    setLoading(state, display) {
      state.loading = display;
    }
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const roles = await axios.get('api/roles');
        commit('setRoles', roles);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async delete({}, id) {
      await axios.delete('api/roles/' + id);
    }
  },
};
